<template>
  <nav>
    <!-- <form-progress /> -->
    <footer>
      <button
        type="button"
        v-if="formState.activeField !== 0"
        :class="$route.name"
        @click="$emit('back')"
        v-html="'&#8592;'"
      ></button>
      <button 
        type="button" 
        class="ryoma--default" 
        :class="{
          'step' : isFunnel,
          'warning': !formState.isValid}"
        @click="nextStep"
        v-html="!formState.isValid ? 'Mandatory' : 'Continue'"></button>
    </footer>
  </nav>
</template>
<script>

export default {
  name: "form-nav",
  inject: ["formState"],
  computed: {
    isFunnel: function() {
      return this.$route.name && this.$route.name.includes('step-')
    }
  },
  methods: {
    nextStep: function() {
      // window.scrollTo({
      //   top: 100,
      //   behavior: 'smooth'
      // });
      this.$emit('next');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/_mixins.scss";

footer {
  display: flex;
  justify-content: space-between;

  @include respond-to(desktop) {
    justify-content: flex-end;
  }

  button {
    margin: 0;

    @include respond-to(desktop) {

      &.step {
        position: fixed;
        bottom: 20vmin;
      }
    }

    &:not(:last-of-type) {
      &:not([class*="step-"]) {
        margin-right: $small_vmin;
        font-size: 5vmin;
      }
    }
  }
}
</style>